import { completeDirectUpload } from "./completeDirectUpload";
import { generatePresignedUrl } from "./generatePresignedUrl";
import { resizeImage } from "./resizeImage";

export async function directUploadWithProgress(
  file,
  metadata = {},
  onProgress
) {
  try {
    // Check if this is a profile photo that needs resizing
    let fileToUpload = file;

    if (
      metadata.file_type === "profile_photo" &&
      file.type.startsWith("image/")
    ) {
      fileToUpload = await resizeImage(file);
    }

    // 1. Get presigned URL from our backend
    const uploadInfo = await generatePresignedUrl(fileToUpload, metadata);

    // 2. Upload directly to S3
    const xhr = new XMLHttpRequest();

    // Set up progress tracking
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable && onProgress) {
        const percentComplete = Math.round((event.loaded / event.total) * 100);

        onProgress(percentComplete);
      }
    };

    // Create a promise to track completion
    const uploadPromise = new Promise((resolve, reject) => {
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(uploadInfo);
        } else {
          reject(new Error(`Upload failed with status ${xhr.status}`));
        }
      };

      xhr.onerror = () => {
        reject(new Error("Network error occurred during upload"));
      };
    });

    // Start the upload
    xhr.open("PUT", uploadInfo.presigned_url, true);

    xhr.setRequestHeader("Content-Type", fileToUpload.type);

    xhr.send(fileToUpload);

    // Wait for upload to complete
    await uploadPromise;

    // 3. Notify backend that upload is complete
    const mediaObject = await completeDirectUpload(
      uploadInfo,
      fileToUpload,
      metadata
    );

    return mediaObject;
  } catch (error) {
    throw error;
  }
}

export default directUploadWithProgress;
